"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('widgets/shared/identity/twoFactorValidation/twoFactorValidation',["require", "exports", "text!./twoFactorValidation.html", "knockout", "services/authenticationService", "scriptLoaders/bundleLoader", "models/userIdentityModel", "store/tokenStore", "helpers/accessTokenHelper", "context"], function (require, exports, templateMarkup, ko, authenticationService, bundleLoader, userIdentityModel, tokenStore, accessTokenHelper, context) {
    "use strict";
    /// <amd-dependency path='text!./twoFactorValidation.html' name='templateMarkup' />

    var TwoFactorValidation = function () {
        function TwoFactorValidation() {
            _classCallCheck(this, TwoFactorValidation);

            this.checkingCredentials = ko.observable(false);
            this.gettingClaims = ko.observable(false);
            this.message = ko.observable('');
            this.messageVisible = ko.observable(false);
            this.code = ko.observable('');
            this.rememberMe = ko.observable(true);
            this.codeMissing = ko.observable(false);
            this.showQrCodePopup = ko.observable(false);
            this.qrCodeSetupImageUrl = userIdentityModel.qrCodeSetupImageUrl;
            this.manualEntryKey = userIdentityModel.manualEntryKey;
            this.recoveryCodes = userIdentityModel.recoveryCodes;
            this.useRecoveryCode = userIdentityModel.useRecoveryCode;
            this.errorMessageTimeout = null;
            this.code.subscribe(function (code) {
                if (code.indexOf(' ') >= 0) {
                    this.code(code.replace(/\s+/g, ''));
                } else {
                    if (code) {
                        this.codeMissing(false);
                    } else {
                        this.codeMissing(true);
                    }
                    if (code.length === 6) {
                        this.validate();
                    }
                }
            }.bind(this));
        }

        _createClass(TwoFactorValidation, [{
            key: "validate",
            value: function validate() {
                var _this = this;

                if (this.code()) {
                    this.checkingCredentials(true);
                    authenticationService.twoFactor(userIdentityModel.userName(), this.code(), this.rememberMe()).fail(function (loginResponse) {
                        _this.checkingCredentials(false);
                        _this.gettingClaims(false);
                        _this.showErrorMessage(loginResponse.responseText);
                    }).done(function (loginResponse) {
                        if (loginResponse !== null) {
                            userIdentityModel.clear();
                            if (loginResponse.token) {
                                _this.gettingClaims(true);
                                tokenStore.setAccessToken(loginResponse.token.accessToken, loginResponse.token.refreshToken, loginResponse.token.accessTokenExpiresIn);
                                accessTokenHelper.setRefreshTimeout();
                                if (loginResponse.recoveryCodes) {
                                    _this.recoveryCodes(loginResponse.recoveryCodes);
                                } else {
                                    authenticationService.getManageInfo().done(function (manageInfoResponse) {
                                        context.hereMapsApiKey = manageInfoResponse.hereMapsApiKey;
                                        context.appBundleUrl = manageInfoResponse.appBundleUrl;
                                        bundleLoader.loadBundleAsyncOnce().done(function () {
                                            require(['app/startup'], function () {
                                                userIdentityModel.setSessionId(manageInfoResponse.sessionId);
                                                userIdentityModel.claims(manageInfoResponse.claims);
                                                userIdentityModel.setUserName(manageInfoResponse.email);
                                                userIdentityModel.setLocalLoginProvider(manageInfoResponse.localLoginProvider);
                                                userIdentityModel.setInsurerId();
                                                userIdentityModel.isAuthenticated(true);
                                                userIdentityModel.requiresTwoFactor(false);
                                                _this.checkingCredentials(false);
                                                _this.gettingClaims(false);
                                            });
                                        });
                                    }).fail(function (err) {
                                        userIdentityModel.isAuthenticated(false);
                                        _this.checkingCredentials(false);
                                        _this.gettingClaims(false);
                                    });
                                }
                            }
                        }
                    });
                } else {
                    this.codeMissing(this.code() === '');
                    this.showErrorMessage('Validation failed');
                }
            }
        }, {
            key: "showSetupInstructions",
            value: function showSetupInstructions() {
                this.showQrCodePopup(true);
                setTimeout(function () {
                    new QRCode($('.qrcode')[0], {
                        text: this.qrCodeSetupImageUrl(),
                        width: 350,
                        height: 350,
                        colorDark: '#000000',
                        colorLight: '#ffffff',
                        correctionLevel: QRCode.CorrectLevel.H
                    });
                }.bind(this), 0);
            }
        }, {
            key: "showErrorMessage",
            value: function showErrorMessage(error) {
                this.message(error);
                this.resetAnimation();
                this.messageVisible(true);
                this.errorMessageTimeout = setTimeout(function () {
                    this.messageVisible(false);
                }.bind(this), 6000);
                this.errorMessageTimeout = setTimeout(function () {
                    this.messageVisible(false);
                }.bind(this), 6000);
            }
        }, {
            key: "resetAnimation",
            value: function resetAnimation() {
                var $loginForm = $('.login-form')[0];
                $loginForm.style.animation = 'none';
                $loginForm.focus(); /* trigger reflow */
                $loginForm.style.animation = null;
            }
        }]);

        return TwoFactorValidation;
    }();

    return { viewModel: TwoFactorValidation, template: templateMarkup };
});
//# sourceMappingURL=twoFactorValidation.js.map;
